// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

/**
 * Save a response the user asked for as a file.
 *
 * A plain `<a href>` would be simpler and is what the CSV exports use, but it cannot carry
 * a header — and the BOM template is localized through `Accept-Language` (§14). On a
 * zh-CN browser, an anchor would hand an English-reading user a Chinese template no matter
 * what the language picker says. Fetching through the API client keeps one locale
 * mechanism for the whole app.
 *
 * The filename comes from `Content-Disposition`, so the server names its own downloads.
 */
export function saveResponseAsFile(response: Response, fallbackName: string): void {
  const disposition = response.headers.get("content-disposition") ?? "";
  const match = /filename="?([^";]+)"?/.exec(disposition);
  const name = match?.[1] ?? fallbackName;

  void response.blob().then((blob) => {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = name;
    document.body.append(anchor);
    anchor.click();
    anchor.remove();
    // Freed on the next tick: revoking synchronously races the download in Safari.
    setTimeout(() => URL.revokeObjectURL(url), 0);
  });
}
